'use client';

import { Box, Skeleton, Typography } from '@mui/material';
import { Link } from '../link';
import { SchemaGenerator } from './SchemaGenerator';
import type { BreadcrumbsProps } from './types';
import { useRoutes } from '@/hooks/useRoutes';
export function Breadcrumbs({
  loading,
  generateSchema = true,
  lastItem,
  ...restProps
}: BreadcrumbsProps) {
  const routes = useRoutes()();
  const items: any[] = !lastItem ? routes : [...routes, {
    title: lastItem,
    route: ''
  }];
  return <Typography component='div' variant='captionRegular__Wallfund' {...restProps} data-sentry-element="Typography" data-sentry-component="Breadcrumbs" data-sentry-source-file="Breadcrumbs.tsx">
      {loading && <Typography color='text.secondary' variant='captionRegular__Wallfund'>
          <Skeleton height={28} width={250} />
        </Typography>}
      <Box className='breadcrumbs-ol' component='ol' sx={{
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      listStyle: 'none',
      '& > li': {
        flexShrink: 0
      },
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
        backgroundColor: 'transparent'
      }
    }} data-sentry-element="Box" data-sentry-source-file="Breadcrumbs.tsx">
        {!loading && items?.map(({
        title,
        route
      }, index) => <Box key={title} className='breadcrumbs-li' component='li' sx={{
        '&:after': {
          content: "''",
          display: 'inline-block',
          borderRight: theme => `1px solid ${theme.palette.text.secondary}`,
          borderBottom: theme => `1px solid ${theme.palette.text.secondary}`,
          width: 6,
          height: 6,
          mx: theme => theme.spacing(1.5),
          transform: 'rotate(45deg)'
        },
        '&:last-child:after': {
          display: 'none'
        }
      }}>
              {index === items.length - 1 ? <Typography sx={{
          color: theme => theme.palette.text.text2
        }} variant='captionRegular__Wallfund'>
                  {title}
                </Typography> : <Typography component={Link} sx={{
          textDecoration: 'none',
          pointerEvents: !route ? 'none' : 'auto',
          color: theme => theme.palette.primaryBrand?.text
        }} href={route || '/'} variant='captionRegular__Wallfund'>
                    {title}
                  </Typography>}
            </Box>)}
      </Box>
      {generateSchema && items?.length && <SchemaGenerator items={items} />}
    </Typography>;
}